import React, { useContext } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';

import { UserContext } from 'commons-ui';

interface IPrivateRouteProps {
	path: any;
	component: any;
}

const PrivateRoute: React.FC<IPrivateRouteProps> = ({ path, component }) => {
	const { isLoggedIn } = useContext(UserContext);
	const history = useHistory();
	if (isLoggedIn) {
		return <Route path={path} component={component} />;
	}
	return (
		<Redirect
			to={{
				pathname: '/login',
				state: { referrer: history.location.pathname }
			}}
		/>
	);
};

export default PrivateRoute;
